export const env = {
  appName: import.meta.env.VITE_APP_NAME || "College ERP",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "/api",
};
